var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 w-full mx-auto"},[_c('div',{staticClass:"animate-pulse flex space-x-2 items-center"},[_c('div',{staticClass:"bg-black bg-opacity-10 rounded flex-grow",class:_vm.isMobile ? 'h-24' : 'h-14'})])])}
var staticRenderFns = []

export { render, staticRenderFns }